import { createRoute } from "@tanstack/react-router";
import { requirePermissions } from "@/app/guards";
import { AUDIT_PERMISSIONS } from "@/app/nav";
import { AuditSearch } from "@/features/audit/AuditSearch";
import { type PageSearch, pageSearch } from "@/routes/paging";
import { staffRoute } from "@/routes/staff";

/** actor is a user id; from and to are RFC 3339; event is the expanded row. */
export type AuditSearchParams = {
  action?: string;
  entity_type?: string;
  entity_id?: string;
  actor?: string;
  from?: string;
  to?: string;
  event?: number;
} & PageSearch;

const nonEmpty = (value: unknown) => (typeof value === "string" && value.trim() !== "" ? value.trim() : undefined);
// Normalised to UTC so the URL and the API always carry the same RFC 3339 form.
const instant = (value: unknown) => {
  const text = nonEmpty(value);
  const ms = text ? Date.parse(text) : NaN;
  return Number.isNaN(ms) ? undefined : new Date(ms).toISOString();
};
const eventId = (value: unknown) => {
  const n = typeof value === "number" ? value : typeof value === "string" && value.trim() !== "" ? Number(value) : NaN;
  return Number.isInteger(n) && n > 0 ? n : undefined;
};

export const auditRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "audit",
  // Set, never omit, each key: the router merges this over the raw query string.
  validateSearch: (search: Record<string, unknown>): AuditSearchParams => ({
    action: nonEmpty(search.action),
    entity_type: nonEmpty(search.entity_type),
    entity_id: nonEmpty(search.entity_id),
    actor: nonEmpty(search.actor),
    from: instant(search.from),
    to: instant(search.to),
    ...pageSearch(search),
    event: eventId(search.event),
  }),
  beforeLoad: ({ context }) => requirePermissions(context.session, AUDIT_PERMISSIONS),
  component: AuditSearch,
});
